<template>
  <div class="box">
    <img class="room" :src="require(`@/assets/mishi/room${pic}.jpg`)" />
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
/* eslint-disable */
export default {
  components: {
    CountTo
  },
  name: 'PaGe2',
  data() {
    return {
      angle: 50,
      startVal: 0,
      duration: 1600,
      countdown: 10,
      mount: 10,
      oldtime: 100,
      time: 100,
      life: 5,
      score: 0,
      percentage: 1,
      title:'过关提示',
      name:'',
      level:1,
      zoom:0.5,
      pic:'1-0'
    }
  },
  computed: {
    progress() {
      return (this.countdown / this.mount) * 100;
    },
    progresstime() {
      return (this.time / this.oldtime) * 100;
    },
  },
  mounted() {
    window.getMessage = this.getMessage;//获取推送数据
    if (this.$route.query.str) {
      this.getMessage(this.$route.query.str)
      setTimeout(this.valChange, 1000)
    };
    if (this.$route.query.zoom) {
      localStorage.setItem('zoom', this.$route.query.zoom);
    };
    this.zoom=localStorage.getItem('zoom');
  },
  beforeDestroy() {
    // 组件销毁时清除计时器
    clearInterval(this.timer);
  },
  methods: {
    
    getMessage(str) {
      console.log(str)
      const strs = str.split('-')
    
      if (strs[0] == 'room') {//密室
        this.pic = strs[1]+"-"+strs[2];
      }
      
    }
  }
}
</script>

<style scoped>
.all {
  zoom: 0.5 ;
}
.contain {
  position: relative;
  width: 200px;
  height: 200px;
}

.room {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  display: block;

}

.common {
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
}

.mask2 {
  transform: rotate(45deg);
  transform-origin: left center;
  left: 100px;
  border-radius: 0 100px 100px 0;
  background: lightgreen;
}

.box {
  background-image: url("../assets/back.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
}

.top_left {
  background-color: aqua;
  width: 250px;
  height: 123px;
  font-size: 30px;
  margin-left: 87px;
  padding-top: 37px;
  border-radius: 0px 0px 30px 30px;
  text-align: center;
  font-weight: bold;
}

.center {
  display: flex;
  margin-top: 35px;
}

.center_left {
  width: 380px;
  height: 380px;
  margin-left: 230px;
  margin-top: 48px;
  position: relative;
}

.in {
  width: 440px;
  height: 400px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-28%, -28%);
  color: #fff;
  text-align: center;
  font-size: 138px;
  font-family: 'bth';
  line-height: 40px;
  padding-top: 40px;
  z-index: 99;
  background: black;
}

.inimg {
  margin-top: 67px;
  width: 150px;
}

.intime {
  font-size: 166px;
  margin-top: 126px
}

.progress-bar {
  transform: rotateX(180deg) rotate(90deg);
}

.center_right {
  margin-left: 240px;
  margin-top: 22px;
}

.mbdc {
  margin-left: 6px;
  height: 68px;
  margin-bottom: 24px;
}

.center_right_text {
  width: 830px;
  height: 205px;
  padding: 5px;
  border-radius: 30px;
  background: -webkit-linear-gradient(45deg, #05f43b, #0be7C1, #00dcdf);
  -moz-linear-gradient: (45deg, #05f43b, #0be7C1, #00dcdf);
  -ms-linear-gradient: (45deg, #05f43b, #0be7C1, #00dcdf);
}

.center_right_text_in {
  width: 770px;
  height: 165px;
  border-radius: 30px;
  background-color: #000;
  font-family: SourceHanSansCN, SourceHanSansCN;
  padding: 20px 30px;
  font-size: 100px;
  color: #fff;
  text-align: center;
  letter-spacing: 10px;
  font-weight: bold;
}

.center_right_bottom {
  display: flex;
  margin-top: 40px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-size: 90px;
  font-weight: bold;
}

.center_right_bottom_left {
  width: 400px;
  height: 189px;
  background: #00FFFC;
  border-radius: 20px 20px 20px 20px;
  padding-top: 56px;
  margin-right: 37px;
  text-align: center;
}

.center_right_bottom_right {
  width: 400px;
  height: 189px;
  background: #05F43B;
  border-radius: 20px 20px 20px 20px;
  padding-top: 56px;
  margin-right: 37px;
  text-align: center;
}

.bottom {
  background-image: url("../assets/smz.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 796px;
  padding-left: 663px;
  height: 127px;
  display: flex;
  margin-left: 234px;
  margin-top: 41px;
}

.line {
  margin-top: 23px;
  margin-right: 40px;
  margin-left: 12px;
}

.canvas {
}
</style>
